import { trackSwitchAuthorizePurchase } from '../../../helpers/switch/analytics';
import { channels } from '../../../constants';
import { PAYMENT_ERROR_GROUPS, PAYMENT_ERROR_TYPES } from '../constants/paymentErrors';
import startPurchase from '../helpers/startPurchase';
import { PAYMENT_STAGES } from '../PaymentContextProvider';

const handleSuccessfulPurchase = (paymentContext, authorizationOutputToken, flexUserMigrationFailed = false) => {
  const { clearPaymentErrors, addPaymentToken, goToPaymentStage } = paymentContext;

  clearPaymentErrors();
  addPaymentToken({
    authorizationOutput: authorizationOutputToken,
    ...(flexUserMigrationFailed ? { flexUserMigrationFailed: true } : {}),
  });

  goToPaymentStage(PAYMENT_STAGES.REQUIRES_FULFILLMENT);
};

const handleUnsuccessfulPurchase = paymentContext => {
  const { raisePaymentError, restartPaymentFlow } = paymentContext;

  raisePaymentError({
    message: 'UNSUCCESSFUL_PURCHASE',
    group: PAYMENT_ERROR_GROUPS.AUTHORIZATION,
    type: PAYMENT_ERROR_TYPES.AUTHORIZATION.UNSUCCESSFUL_PURCHASE_RETRY,
  });
  restartPaymentFlow();
};

/*
  Responsible for moving from the 3DS stage to either:
  - Fulfillment, on success
  - Payment Method Capture, on failure (to allow a retry)
*/
const paymentAuthorizedTransition = (paymentContext, authorizationOutputToken) => async dispatch => {
  const { tokens, resolvedUpgradeOffer, selectedPlanOverride, isWebview } = paymentContext;
  const channel = isWebview ? channels.app : channels.online;

  const authorisePurchasePayload = {
    targetOfferId: resolvedUpgradeOffer.id,
    targetOfferPlanCode: selectedPlanOverride?.planCode ?? resolvedUpgradeOffer.planCode,
    isFlexFlow: paymentContext.isFlexFlow,
    authorizationToken: authorizationOutputToken,
    is3dsInitiatedOnEnforcedVerification: tokens.is3dsInitiatedOnEnforcedVerification,
    channel,
    ...(tokens.flexUserMigrationFailed ? { flexUserMigrationFailed: true } : {}),
  };

  if (tokens.isUsingExistingMethod) {
    authorisePurchasePayload.isAddingPaymentMethod = false;
  } else {
    authorisePurchasePayload.isAddingPaymentMethod = true;
    authorisePurchasePayload.paymentMethodToken = tokens.paymentMethod;
  }

  const { complete, flexUserMigrationFailed = false } = await dispatch(startPurchase(authorisePurchasePayload));

  if (complete) {
    trackSwitchAuthorizePurchase(true);
    // All users (flex and non-flex) move to fulfillment
    // Flex-specific API handling is done in PaymentProcessing component
    handleSuccessfulPurchase(paymentContext, authorizationOutputToken, flexUserMigrationFailed);
  } else {
    // Purchase unsuccessful, return to payment method capture to retry the process
    trackSwitchAuthorizePurchase(false);
    handleUnsuccessfulPurchase(paymentContext);
  }
};

export default paymentAuthorizedTransition;
